import { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const RealTimeCounters = () => {
  const [counters, setCounters] = useState({
    users: 0,
    businesses: 0,
    visits: 0
  });

  const targetValues = {
    users: 145,
    businesses: 256,
    visits: 8923
  };

  useEffect(() => {
    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;

    const incrementCounters = () => {
      setCounters(prev => ({
        users: Math.min(prev?.users + Math.ceil(targetValues?.users / steps), targetValues?.users),
        businesses: Math.min(prev?.businesses + Math.ceil(targetValues?.businesses / steps), targetValues?.businesses),
        visits: Math.min(prev?.visits + Math.ceil(targetValues?.visits / steps), targetValues?.visits)
      }));
    };

    const timer = setInterval(incrementCounters, interval);

    return () => clearInterval(timer);
  }, []);

  const stats = [
    {
      id: 1,
      icon: "Users",
      label: "Usuarios Registrados",
      value: counters?.users?.toLocaleString('es-CO'),
      color: "bg-primary",
      textColor: "text-primary-foreground"
    },
    {
      id: 2,
      icon: "Store",
      label: "Negocios Activos",
      value: counters?.businesses?.toLocaleString('es-CO'),
      color: "bg-secondary",
      textColor: "text-secondary-foreground"
    },
    {
      id: 3,
      icon: "Eye",
      label: "Visitas Totales",
      value: counters?.visits?.toLocaleString('es-CO'),
      color: "bg-accent",
      textColor: "text-accent-foreground"
    }
  ];

  return (
    <section className="py-16 px-6 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats?.map((stat) => (
            <div
              key={stat?.id}
              className="bg-card rounded-2xl shadow-card p-8 text-center transition-transform hover:scale-105"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 ${stat?.color} ${stat?.textColor} rounded-xl mb-4`}>
                <Icon name={stat?.icon} size={32} />
              </div>
              <div className="text-4xl font-bold text-foreground mb-2">
                {stat?.value}
              </div>
              <div className="text-sm text-muted-foreground font-medium">
                {stat?.label}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-muted-foreground flex items-center justify-center gap-2">
            <Icon name="TrendingUp" size={20} color="var(--color-success)" />
            <span>Actualizado en tiempo real - Última actualización: {new Date()?.toLocaleDateString('es-CO', { day: '2-digit', month: '2-digit', year: 'numeric' })}</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default RealTimeCounters;